import { render, staticRenderFns } from "./sourceAnalysis.vue?vue&type=template&id=5d520688&scoped=true&"
import script from "./sourceAnalysis.vue?vue&type=script&lang=js&"
export * from "./sourceAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./sourceAnalysis.vue?vue&type=style&index=0&id=5d520688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d520688",
  null
  
)

export default component.exports